import Stack from '@mui/material/Stack';
import styled from '@mui/material/styles/styled';

const StyledBoxBase = styled(Stack)`
	align-items: center;
	justify-content: center;
	flex: 1;
	background-color: ${({theme}) => theme.palette.common.black};
	border-radius: 5.38px;
	padding-inline: 10px;
`;

const StyledBoxApple = styled(StyledBoxBase)`
	padding-block: 7.15px;
`;

const StyledBoxGoogle = styled(StyledBoxBase)`
	padding-block: 5.72px;
`;

export {StyledBoxApple, StyledBoxGoogle};
